<script setup>
import { ref, shallowRef, onMounted, defineAsyncComponent } from 'vue';

const Version = shallowRef(null);
const componentLoaded = ref(false);

function pickVersion() {
  Version.value = defineAsyncComponent(
    () => import(`../../layouts/clients/bingo/BingoV1.vue`),
  );
  componentLoaded.value = true;
}

onMounted(() => {
  pickVersion();
});
</script>

<template>
  <Version v-if="componentLoaded" />
</template>
